//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { axiosGet } from '../../../../axios/axios.js'
import TableServer from '../../../../components/Table/Table.vue'
import { formatTrueFalse } from '../../../../components/helpers.js'

export default {
  components: {
    TableServer
  },
  props: {
    organizationId: {
      type: Number,
      default: null
    },
    formId: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      loading: false,

      urlBase: '/service/delta/vehicleGroupType/list',
      updateEvent: 'update-vehicleGroupType',
      filterType: 'vehicleGroupType',

      columns: this.prepareColumns([
        {
          name: 'name',
          label: 'Наименование',
          defaultWidth: 110,
          sortable: true
          // columnFormat: 'recordCardLink',
          // columnObjectType: 'vehicleGroupType',
          // columnObjectSubType: 'fenceCategory'
        },
        {
          name: 'actual',
          label: 'Актуальный',
          defaultWidth: 80,
          format: formatTrueFalse,
          sortable: true
        },
        {
          name: 'vehiclesCount',
          label: 'Число ТС',
          defaultWidth: 80,
          sortable: true
        },
        {
          name: 'description',
          label: 'Описание',
          sortable: true
        },
        {
          name: 'organization',
          label: 'Организация',
          format: value => value && value.name || null,
          sortable: true
        }
      ])
    }
  },
  computed: {
    additionalUrlParams: function () {
      const params = {}
      params.extendedResult = true
      if (this.organizationId) {
        params.organizationId = this.organizationId
      }
      return params
    },
    visibleColumns: function () {
      let columns = this.columns || []
      if (this.organizationId) {
        columns = columns.filter(column => column.name !== 'organization')
      }
      return columns.map(column => column.name)
    }
  },
  methods: {
    getObjectCardUrl: function (employee) {
      return this.$d_getUrlObjectCard(employee.id, 'vehicleGroupType')
    },
    showColumnMobile: function (col) {
      const val = col.value
      const hasColumnValue = val != null && !!val && val.length > 0
      return col.showAlways || hasColumnValue
    },
    prepareColumns: function (columns) {
      for (const column of columns) {
        if (!column.field) {
          column.field = column.name
        }
        if (!column.align) {
          column.align = 'left'
        }
        if (column.sortable == null) {
          column.sortable = false
        }
      }
      return columns
    }
  }
}

